<template>
    <div>
        <ul>
            <li v-for="d in logData">
                <a href="#" @click.prevent="openLog(d.filename)">{{ d.date }}</a>
            </li>
        </ul>
       
    </div>
</template>
<script>
import urlApi from '@/router/urlApiV2.js'
export default {
    name: 'LogAgendamentoModal',
    mounted() {
        this.$http.get(urlApi + '/logs/relatorios/schedule')
        .then(response => {
            this.logData = response.data.dados
        })
    },
    data() {
        return {
            logData: null
        }
    },
    methods: {
        openLog(filename) {
            let routeData = this.$router.resolve({name: 'LogsAgendamento', params: {filename}});
            window.open(routeData.href, '_blank');
        }
    }
    
}
</script>